import styled from "styled-components";
import { device } from "../breakpoints";

export const SpotlightCardHolder = styled.div`
  width: 560px;
  height: 100%;
  padding: 50px 60px;
  box-shadow: 0 0 10px rgba(158, 158, 158, 0.14);
  border-radius: 12px;
  flex-shrink: 0;
  background-color: #fff;
  position: relative;
  overflow: hidden;
  &::after {
    content: "";
    position: absolute;
    width: 625px;
    height: 336px;
    left: 352px;
    top: 0px;
    background: linear-gradient(
      295.34deg,
      #d9d9d9 -6.27%,
      rgba(217, 217, 217, 0) 73.4%
    );
    transform: rotate(45deg);
  }
  @media ${device.mobile} {
    width: 100%;
    padding: 20px;
    height: 100%;
    &::after {
      left: 180px;
    }
  }
`;
export const SpotlightMedia = styled.a`
  font-family: "Open Sans";
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  text-transform: uppercase;
  @media ${device.mobile} {
    font-size: 14px;
    line-height: 19px;
  }
`;
export const SpotlightTitle = styled.h4`
  font-family: "Raleway";
  font-size: 32px;
  line-height: 38px;
  font-weight: 500;
  color: #000;
  margin: 20px 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  a {
    color: #000;
  }
  @media ${device.mobile} {
    font-size: 24px;
    line-height: 28px;
    margin: 18px 0 24px 0;
  }
`;
export const SpotlightFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  > p {
    font-family: "Open Sans";
    font-size: 16px;
    line-height: 22px;
    color: #9b9b9b;
  }
  @media ${device.mobile} {
    > p {
      font-size: 14px;
      line-height: 19px;
    }
  }
`;
